import { FC, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

import styles from './index.module.css'
//import { faXmark } from "@fortawesome/free-solid-svg-icons"
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import gif from '../../assets/gifs/gif_ia_response.gif'

import ChatIaPerson from './icones/ChatIaPerson.svg'
import SVG from 'react-inlinesvg';
import ChatIaResponse from './icones/IaResponse.svg'
import CustomerIa from './icones/CustomerIA.svg'
import { rtcToTextChatIA } from "../../functions/mask"
import api from "../../services/api"
import { usePluginspace } from "../../hooks/usePluginspace"
import { MdClose } from "react-icons/md"

export interface MessageModel {
  user: number
  type: 'in' | 'out'
  text: string
  time?: number
  template?: boolean
  image?: string | null 
  webAppLink?: string | null
}

type Props = {
  isDrawer?: boolean
}

type LocalSavedMessageType = {
  lastMessage: Date,
  messages: MessageModel[],
  sessionId: string;
}

type UserInfoModel = {
  name: string
  avatar: string
}

type PluginconfigType = {
  id: number;
  name: string;
  content: any;
  plugintemplateId: number;
  plugintypeId: number;
}

type TemplateType = {
  id: number;
  name: string;
  image: string | null;
  parameters: string;
  plugintypeId: number;
  pluginconfig: PluginconfigType;
  typeIntegration: string;
  able: boolean | null;
}

type SendMessageType = {
  inputText?: string;
  sessionId: string;
  agentId?: string;
  agentAliasId?: string;
  prompt?: string;
  humanized?: boolean;
}


const NewChatIa: FC<any> = () => {
  const { getToken, registerAccess, getThisPluginspace, getLocations } = usePluginspace();
  const navigate = useNavigate();
  
  console.log('✨ NewChatIa COMPONENT MOUNTED');
  
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [hasMicActive, setHasMicActive] = useState<boolean>(false)
  const [hasAudioActive, setHasAudioActive] = useState<boolean>(true)
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string>('')
  const [agentId, setAgentId] = useState('');
  const [agentName, setAgentName] = useState('');
  const [agentAliasId, setAgentAliasId] = useState('');
  const [messages, setMessages] = useState<MessageModel[]>([{
    user: 0,
    type: 'in',
    text: 'Olá, o que você precisa?',
    time: new Date().getTime()
  }])
  const [userInfos] = useState<UserInfoModel[]>([
    {
      name: 'Ninegrid',
      avatar: 'avatars/300-6.jpg',
    },
    {
      name: 'Você',
      avatar: 'avatars/300-6.jpg',
    }
  ])




  const [sessionId, setSessionId] = useState('');
  const [imageResponse, setImageResponse] = useState<string | null>(null);
  const [webAppLink, setWebAppLink] = useState<string | null>(null);

  const [messageLoading, setMessageLoading] = useState<MessageModel>({
    user: 0,
    type: 'in',
    text: '',
  })

  const textbox = useRef(null);
  /* Nova funcionalidade de audio */
  const [isListening, setIsListening] = useState(false);
  const [sourceLanguage, setSourceLanguage] = useState<string>('pt');
  const [targetLanguage, setTargetLanguage] = useState<string>('pt');
  const [fillColor, setFillColor] = useState<string>('#000000');
  const recognitionRef = useRef<SpeechRecognition | null>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  /** Lista de Icones */
  const languageMap: { [key: string]: string } = {
    'ru': 'ru-RU',
    'pt': 'pt-BR',
    'it': 'it-IT',
    'en': 'en-US',
    'de': 'de-DE',
    'fr': 'fr-FR',
    'et': 'et-EE',
    'es': 'es-ES',
    'zh': 'zh-CN',
    'ar': 'ar-SA',
  };


  const sendMessage = (type: 'in' | 'out', user: number, messageReceived?: string) => {
    console.log('📨 sendMessage chamada:', { type, user, messageReceived: messageReceived || message });
    
    const newMessages = [...messages]
    const newMessage: MessageModel = {
      user: user,
      type: type,
      text: messageReceived ? messageReceived : message,
      time: new Date().getTime(),
    }
    newMessages.push(newMessage)
    setMessages(newMessages)
    toggleChatUpdate()
    if (type === 'out') {
      console.log('⏱️ AGENDANDO sendMessageNinegridIA com 200ms delay');
      setTimeout(() => {
        console.log('⏲️ EXECUTANDO sendMessageNinegridIA agora');
        try {
          sendMessageNinegridIA(message, newMessages)
        } catch (e) {
          console.error('❌ Erro ao chamar sendMessageNinegridIA:', e);
        }
      }, 200);
      setMessage('')
    }
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      if (message) sendMessage('out', 1)
    }
  }

  const getTimeDifference = (timeMessage: number) => {
    const dateMsg = new Date(timeMessage);
    const today = new Date()
    const timeNow = today.getTime();
    const timeMinutes = Math.trunc((timeNow - timeMessage) / 60000)
    return timeMinutes <= 0 ?
      'Enviado agora' :
      today.toLocaleDateString() === dateMsg.toLocaleDateString() ?
        dateMsg.toLocaleTimeString().substring(0, 5) :
        `${dateMsg.toLocaleDateString()} ${dateMsg.toLocaleTimeString().substring(0, 5)}`
  }

  const animateMessageLoading = () => {
    const now = new Date().getTime() / 300;
    switch (Math.trunc(now % 3)) {
      case 0:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '.'
        });
        break;
      case 1:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '..'
        });
        break;
      case 2:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
      default:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
    }
  }


  const processResponse = (responseText: string) => {
    const linkRegex = /https?:\/\/[^\s]+/g;

    // Substituir URLs por "clique aqui" para a leitura de voz e links amigáveis para o visual
    const processedTextForDisplay = responseText.replace(linkRegex, (url) => {
      return `<a href="${url}" target="_blank" style="color: blue; text-decoration: underline;">saiba mais</a>`;
    });


    const processedTextForSpeech = responseText.replace(linkRegex, 'saiba mais...');

    if (hasAudioActive) {
      // Reproduzir a resposta em áudio
      const utterance = new SpeechSynthesisUtterance(processedTextForSpeech);
      utterance.lang = 'pt-BR'; // Definimos a linguagem para português do Brasil
      window.speechSynthesis.speak(utterance);

    }

    return processedTextForDisplay



  };


  const sendMessageNinegridIA = async (messageToSend: string, newMessages: MessageModel[]) => {
  try {
    console.log('🚀 ENVIANDO MENSAGEM PARA API - Prompt:', messageToSend);
    setLoading(true);
    let messageLanguage = '';

    const classifyResult = await api
      .post(
        `/api/classification-ia/classify`,
        {
          prompt: messageToSend,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error('❌ Erro ao classificar mensagem:', error);
        return { success: false, data: null };
      });

    console.log('✅ RESPOSTA RECEBIDA:', classifyResult);
    let newSessionId;
    let messageIA = '';

    if (classifyResult && classifyResult.success) {
      if (classifyResult.data && classifyResult.data.target && classifyResult.data.success) {
        const classifyData = classifyResult.data;
        const target = classifyData.target;
        
        if (target === 'Greeting') {
          console.log('🎉 SAUDAÇÃO DETECTADA');
          messageIA = classifyData.greetingResponse || 'Olá! Como posso ajudar você hoje?';
          setLoading(false);
          newSessionId = sessionId;

          const newMessage: MessageModel = {
            user: 0,
            type: 'in',
            text: processResponse(messageIA),
            time: new Date().getTime(),
          };
          
          newMessages.push(newMessage);
          console.log('📝 MENSAGEM DE SAUDAÇÃO ADICIONADA');
        }
        
        else if (target === 'AGENTE') {
          const objSend: any = {
            inputText: messageLanguage + ' ' + messageToSend,
            sessionId,
            targetLanguage,
            sourceLanguage
          };

          const timeoutPromise = new Promise((_, reject) => 
            setTimeout(() => {
              console.log('Aviso: Tempo limite de resposta excedido (200s)');
              reject(new Error('Tempo limite excedido'));
            }, 200000) // 200 segundos
          );

          if (agentId) objSend.agentId = agentId;
          if (agentAliasId) objSend.agentAliasId = agentAliasId;
          
          const result = await api.post(
            `/api/chatIA/question`,
            objSend,
            {
              headers: {
                'Authorization': `Bearer ${await getToken()}`
              }
            }
          ).then(res => res.data).catch(err => err.response.data);

          const res = await Promise.race([result, timeoutPromise]);

          setLoading(false);
          newSessionId = sessionId;
          messageIA = '';

          if (res.success && res.data.response && res.data.completion && res.data.response.sessionId) {
            messageIA = res.data.completion;
            setSessionId(res.data.response.sessionId);
            newSessionId = res.data.response.sessionId;
            
            // Adiciona a mensagem ao array de mensagens
            const newMessage: MessageModel = {
              user: 0,
              type: 'in',
              text: processResponse(messageIA),
              time: new Date().getTime(),
            };
            newMessages.push(newMessage);
          } else {
            messageIA = 'Não consegui encontrar uma resposta para sua mensagem';
            
            // Adiciona a mensagem ao array de mensagens
            const newMessage: MessageModel = {
              user: 0,
              type: 'in',
              text: processResponse(messageIA),
              time: new Date().getTime(),
            };
            newMessages.push(newMessage);
          }
        }

        else if (target === 'AB') {
          const timeoutPromise = new Promise((_, reject) => 
            setTimeout(() => {
              console.log('Aviso: Tempo limite de resposta excedido (200s)');
              reject(new Error('Tempo limite excedido'));
            }, 200000) // 200 segundos
          );

          const objSend: SendMessageType = {
            prompt: messageToSend + ' ' + messageLanguage,
            humanized: true,
            sessionId,
          };

          const result = await api
            .post(
              `/api/analyse-ia/analyse`,
              objSend,
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            )
            .then((response) => response.data)
            .catch((e) => e);

          const res = await Promise.race([result, timeoutPromise]);

          setLoading(false);

          if (res.success && res.data.humanizedAnswer) {
            try {
              const humanizedData = JSON.parse(res.data.humanizedAnswer);
              
              // Verificar se é um array de itens e processá-los individualmente
              if (Array.isArray(humanizedData) && humanizedData.length > 0) {
                // Para cada item no array, criar uma mensagem separada
                humanizedData.forEach(item => {
                  if (item.message) {
                    const newMessage: MessageModel = {
                      user: 0,
                      type: 'in',
                      text: processResponse(item.message),
                      time: new Date().getTime(),
                      image: item.image || item.imageUrl || null,
                      webAppLink: item.webAppLink || item.webapp || null
                    };
                    
                    newMessages.push(newMessage);
                  }
                });
              } else if (typeof humanizedData === 'object' && humanizedData.message) {
                // Se for um objeto único com a propriedade message
                const newMessage: MessageModel = {
                  user: 0,
                  type: 'in',
                  text: processResponse(humanizedData.message),
                  time: new Date().getTime(),
                  image: humanizedData.image || humanizedData.imageUrl || null,
                  webAppLink: humanizedData.webAppLink || humanizedData.webapp || null
                };
                
                newMessages.push(newMessage);
              } else {
                // Fallback para mensagem de erro
                messageIA = 'Não consegui processar a resposta adequadamente';
                const newMessage: MessageModel = {
                  user: 0,
                  type: 'in',
                  text: processResponse(messageIA),
                  time: new Date().getTime()
                };
                
                newMessages.push(newMessage);
              }
            } catch (parseError) {
              console.error('Erro ao processar humanizedAnswer:', parseError);
              
              // Fallback para o comportamento anterior
              messageIA = 'Não consegui processar a resposta';
              const newMessage: MessageModel = {
                user: 0,
                type: 'in',
                text: processResponse(messageIA),
                time: new Date().getTime()
              };
              
              newMessages.push(newMessage);
            }
          } else {
            messageIA = 'Não consegui encontrar uma resposta para sua mensagem, pode ser mais específico por favor, ou tente novamente mais tarde.';
            const newMessage: MessageModel = {
              user: 0,
              type: 'in',
              text: processResponse(messageIA),
              time: new Date().getTime()
            };
            
            newMessages.push(newMessage);
          }
        }
      }
    } else {
      console.error('Erro na classificação IA:', classifyResult);
      setLoading(false);
      messageIA = 'Não consegui encontrar uma resposta para sua mensagem, pode ser mais específico por favor, ou tente novamente mais tarde.';
      
      // Adiciona mensagem de erro ao array
      const newMessage: MessageModel = {
        user: 0,
        type: 'in',
        text: processResponse(messageIA),
        time: new Date().getTime()
      };
      
      newMessages.push(newMessage);
      
      newSessionId = sessionId;
    }

    // Como já adicionamos todas as mensagens necessárias aos newMessages,
    // não precisamos criar mais nenhuma mensagem aqui.
    // Remova este bloco que estava duplicando a última mensagem:
    /*
    const newMessage: MessageModel = {
      user: 0,
      type: 'in',
      text: processResponse(messageIA),
      time: new Date().getTime(),
    }
    newMessages.push(newMessage)
    */
    
    setMessages(newMessages);
    saveLocalMessages(newMessages, newSessionId || sessionId);
    toggleChatUpdate();
    scrollToBottm();
  } catch (e) {
    console.error('Erro no processamento da mensagem:', e);
    setLoading(false);
    const newMessage: MessageModel = {
      user: 0,
      type: 'in',
      text: 'Não consegui encontrar uma resposta para sua mensagem, pode ser mais específico por favor, ou tente novamente mais tarde.',
      time: new Date().getTime(),
    };
    newMessages.push(newMessage);
    setMessages(newMessages);
    saveLocalMessages(newMessages, sessionId);
    toggleChatUpdate();
  }
};

  const toggleChatUpdate = () => {
    toggleChatUpdateFlat(!chatUpdateFlag)
    setTimeout(() => {
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)
  }

  const saveLocalMessages = (newMessages: MessageModel[], newSessionId: string) => {
    try {
      localStorage.setItem(window.btoa('messagesIA'), window.btoa(JSON.stringify({
        lastMessage: new Date(),
        messages: newMessages,
        sessionId: newSessionId
      })))
    } catch (error) {

    }
  }

  const adjustHeightTextArea = () => {
    if (textbox && textbox.current) {
      const styleTextbox: any = textbox.current
      if (styleTextbox.scrollHeight <= 145) {
        styleTextbox.style.height = "inherit";
        styleTextbox.style.height = `${styleTextbox.scrollHeight}px`;
        const divChat = document.getElementById('chat-body');
        const divFooter = document.getElementById('kt_drawer_chat_messenger_footer');
        if (divChat && divFooter) {
          divFooter.style.height = `calc(${110 + (styleTextbox.scrollHeight - 64)}px - 2em)`
          divChat.style.height = `calc(100vh - 110px - 2em - 60px - ${(styleTextbox.scrollHeight - 64)}px)`
        }
      }
    }
  }

  const scrollToBottm = () => {
    const divChat = document.getElementById('chat-scroll')
    if (divChat) {
      divChat.scrollTo(0, divChat.scrollHeight)
    }
  }

  const verifyAgent = async () => {
    setLoading(true)
    const templateRes = await api.get(
      `/api/plugintemplate/ia`,
      {
        headers: {
          Authorization: `Bearer ${await getToken()} `,
        },
      }).then(res => res.data).catch(err=> err.response.data)

    let modelId = ''
    let agentName = ''
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig && template.pluginconfig.content && template.pluginconfig.content.able) {
          modelId = template.pluginconfig.content.modelId
          agentName = template.pluginconfig.content.agentName
        }
      })
    }
    if (modelId && agentName) {
      const agentItems = await api.get(`/api/agent-ia/listAgentNIS/${agentName}`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()} `,
          },
        }).then(res => res.data).catch(err=> err.response.data)
      if (agentItems.agentId) setAgentId(agentItems.agentId)
      if (agentItems.agentAliasId) setAgentAliasId(agentItems.agentAliasId)
      if (agentItems.agentName) setAgentName(agentItems.agentName.split("-")[0])
    }
    setLoading(false)
  }

  useEffect(() => {
    verifyAgent();
    const messagesIALocal = localStorage.getItem(window.btoa('messagesIA'))

    if (messagesIALocal) {
      const messageLocalSaved: LocalSavedMessageType = JSON.parse(window.atob(messagesIALocal));
      if (
        messageLocalSaved &&
        messageLocalSaved.lastMessage &&
        messageLocalSaved.messages &&
        messageLocalSaved.sessionId
      ) {
        if ((new Date().getTime() - new Date(messageLocalSaved.lastMessage).getTime()) < (1000 * 60 * 60 * 24)) {
          setMessages(messageLocalSaved.messages)

        } else {
          localStorage.removeItem(window.btoa('messagesIA'))
        }
      }
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = true;

      recognition.lang ='pt-BR';

      recognition.onresult = (event: SpeechRecognitionEvent) => {
        const transcript = event.results[event.results.length - 1][0].transcript.trim();
        setMessage((prevText) => prevText + ' ' + transcript);
      };

      recognitionRef.current = recognition;
    } else {
      alert('Seu navegador não suporta a API de Reconhecimento de Fala');
    }
  }, [])

  useEffect(() => {
    scrollToBottm()
  }, [messages.length])

  function changeLanguageSpeechRecognition() {
    try {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SpeechRecognition) {
        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = false;
        setSourceLanguage(sourceLanguage)


        recognition.lang = 'pt-BR';

        recognition.onresult = (event: SpeechRecognitionEvent) => {
          const transcript = event.results[event.results.length - 1][0].transcript.trim();
          setMessage((prevText) => prevText + ' ' + transcript);
        };

        recognitionRef.current = recognition;
      } else {
        alert('Seu navegador não suporta a API de Reconhecimento de Fala');
      }
    } catch (error) {
      alert('Seu navegador não suporta a API de Reconhecimento de Fala');
    }

  }

  useEffect(() => {
    changeLanguageSpeechRecognition()
  }, [sourceLanguage])

  const requestMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (stream) {
        console.log('Microphone permission granted');
        setHasMicActive(true);
      }
    } catch (error) {
      console.error('Microphone permission denied', error);
      setHasMicActive(false);
    }
  };

  useEffect(() => {
    requestMicrophonePermission();
  }, []);


  // Função para iniciar o reconhecimento de voz
  const startListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);
    }
  };

  useEffect(() => {
    if (!hasAudioActive) {
      window.speechSynthesis.cancel();
    }
  }, [hasAudioActive])


  return (
    <div
      className={styles['chat-ia']}
      style={{
        boxShadow: '0px 0px 40px -3px rgba(0, 0, 0,0.2)',
        backgroundColor: '#BDBDBD',
        fontFamily: "Poppins, Helvetica, 'sans-serif'",
      }}
    >
      <div className={styles['content-chat-ia']}  id="kt_drawer_chat_messenger">
        <>
          <div className={` ${styles['header-chat-ia']} divide-x-2 relative`} id="kt_drawer_chat_messenger_header">
            <div
             className={` ${styles['title']}`}
             style={{
              flexGrow: 0,
            }}
             >
              <div  className={`${styles['title-content']}`} >
                <div className={`${styles['title-content-content']}`}>
                 
                    <SVG src={ChatIaPerson} style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px',
                  }}
                    color={fillColor}
                  />
                  <div>
                    <a>{agentName}</a>
                    <div className={`${styles['badge-title']}`} >
                      <span className={`${styles['badge']}`}></span>
                      <span className={`${styles['text']}`}>Online</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className={styles['icon_return']} style={{ cursor: 'pointer' }} >
            <MdClose  onClick={() => navigate(-1)}/>
            </div>
          </div>

          <div className={styles['chat-body']} id="chat-body">
            <div id="chat-scroll" className={styles['chat-inner']}>
              {
                [...messages, loading ? messageLoading : null].map((message, index) => {
                  if (message) {
                    const userInfo = userInfos[message.user];
                    const state = message.type === 'in' ? 'info' : 'primary';
                    const templateAttr = {};
                    if (message.template) {
                      Object.defineProperty(templateAttr, 'data-kt-element', {
                        value: `template-${message.type}`,
                      });
                    }

                    return (
                      <div
                        key={`message${index}`}
    
                        className={`${styles['message']} ${styles['message-' + message.type]}`}
                        {...templateAttr}
                      >
                        <div className={styles['title']}>
                          {message.type === 'in' ? (
                            <>
                              <div className={styles['title-content']}>
                              
                                <SVG src={ChatIaResponse} style={{
                                  width: '30px',
                                  height: '30px',
                                  borderRadius: '2px',
                                }}
                                  color={fillColor}
                                />
                                  {/*<span>{message.time ? getTimeDifference(message.time) : ''}</span>*/}

                              </div>
                            </>
                          ) : (
                            <>
                              <div className={styles['title-content']} >
                                {/*<span>{message.time ? getTimeDifference(message.time) : ''}</span>*/}
                                <SVG src={CustomerIa} style={{
                                  width: '30px',
                                  height: '30px',
                                  borderRadius: '2px',
                                }}
                                  color={fillColor}
                                />

                              </div>
                            </>
                          )}
                        </div>

                        <div className={message.text === '' ? styles['message-text-loading'] : styles["message-text"]} data-kt-element="message-text">
                          {
                            message.text === '' ? (
                              <img src={gif} alt="Processing..." style={{ width: '35px', height: '35px' }} /> // Exibe o GIF animado
                            ) : (
                              <>
                                {message.image && (
                                  <div className={styles['product-image-container']}>
                                    <img 
                                      src={message.image} 
                                      alt="Produto" 
                                      className={styles['product-image']} 
                                      style={{ 
                                        maxWidth: '100%', 
                                        borderRadius: '8px', 
                                        marginBottom: '10px',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)' 
                                      }} 
                                    />
                                  </div>
                                )}
                                <span dangerouslySetInnerHTML={{ __html: rtcToTextChatIA(message.text) }} />
                                {message.webAppLink && (
                                  <div className={styles['webapp-link-container']} style={{ marginTop: '10px' }}>
                                    <a 
                                      href={message.webAppLink} 
                                      target="_blank" 
                                      rel="noopener noreferrer" 
                                      className={styles['webapp-link']}
                                      style={{
                                        display: 'inline-block',
                                        padding: '8px 16px',
                                        backgroundColor: '#6993ff',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                      }}
                                    >
                                      Ver produto na loja
                                    </a>
                                  </div>
                                )}
                              </>
                            )
                          }
                        </div>
                      </div>
                    );
                  }
                })
              }
            </div>
          </div>

          <div className={styles['footer-chat']} id="kt_drawer_chat_messenger_footer">
            <div className={styles['footer-chat-content']}>
              <button >
                {!hasAudioActive ?
                  (
                    <svg width="20" height="28.57" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setHasAudioActive(true)}>
                      <path d="M23.4608 0.819687C19.668 4.17812 15.8963 7.55774 12.1035 10.9056C11.8493 11.1387 11.4361 11.2976 11.0865 11.3082C9.38078 11.3505 7.68567 11.3082 5.97996 11.3294C2.39905 11.3611 0.0364919 13.7343 0.00470863 17.3046C-0.00588579 18.9256 0.00470863 20.5359 0.00470863 22.1569C0.00470863 25.8967 2.36727 28.2487 6.1071 28.2593C7.77043 28.2593 9.42316 28.2381 11.0865 28.2804C11.3937 28.2804 11.7645 28.4182 11.9976 28.6195C14.286 30.6218 16.5532 32.6453 18.8204 34.6583C20.346 36.0144 21.8822 37.3811 23.4078 38.7371C24.0329 39.2986 24.7109 39.7224 25.622 39.5635C27.3383 39.2457 28.2283 38.1968 28.2283 36.417C28.2283 30.8973 28.2283 25.3882 28.2283 19.8685V3.23522C28.2283 2.49361 28.1435 1.77319 27.6456 1.1693C26.4802 -0.239756 24.838 -0.398672 23.4608 0.819687Z" fill={fillColor} />
                      <path d="M43.654 19.7945L49.269 14.1794C50.2437 13.2047 50.2437 11.5944 49.269 10.6197C48.2944 9.645 46.684 9.645 45.7093 10.6197L40.0943 16.2347L34.4792 10.6197C33.5045 9.645 31.8942 9.645 30.9195 10.6197C29.9448 11.5944 29.9448 13.2047 30.9195 14.1794L36.5345 19.7945L30.9195 25.4095C29.9448 26.3842 29.9448 27.9945 30.9195 28.9692C31.8942 29.9439 33.5045 29.9439 34.4792 28.9692L40.0943 23.3542L45.7093 28.9692C46.684 29.9439 48.2944 29.9439 49.269 28.9692C50.2437 27.9945 50.2437 26.3842 49.269 25.4095L43.654 19.7945Z" fill={fillColor} />
                    </svg>

                  ) :

                  (
                    <svg width="20" height="28.57" viewBox="0 0 50 41" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setHasAudioActive(false)}>
                      <path d="M23.9791 0.837797C20.1025 4.27043 16.2476 7.72472 12.371 11.1465C12.1111 11.3848 11.6888 11.5472 11.3314 11.558C9.58803 11.6013 7.85547 11.558 6.11209 11.5797C2.45205 11.6122 0.0372982 14.0377 0.00481267 17.6869C-0.00601583 19.3437 0.00481267 20.9896 0.00481267 22.6464C0.00481267 26.4689 2.41957 28.8728 6.24203 28.8836C7.9421 28.8836 9.63135 28.8619 11.3314 28.9053C11.6454 28.9053 12.0244 29.046 12.2627 29.2518C14.6016 31.2984 16.9189 33.3666 19.2362 35.424C20.7955 36.8101 22.3657 38.2069 23.925 39.593C24.5638 40.1669 25.2569 40.6 26.1881 40.4376C27.9423 40.1128 28.8519 39.0407 28.8519 37.2215C28.8519 31.5799 28.8519 25.9491 28.8519 20.3074V3.30669C28.8519 2.5487 28.7653 1.81236 28.2564 1.19514C27.0652 -0.245053 25.3868 -0.407481 23.9791 0.837797Z" fill={fillColor} />
                      <path d="M49.621 16.3666C48.7222 11.3313 46.145 7.25982 42.2143 4.05459C40.6658 2.78765 38.5001 3.68642 38.1319 5.6572C37.9045 6.90248 38.6625 7.68213 39.4855 8.44013C44.4774 13.0422 46.08 19.5393 43.7844 25.8957C42.8965 28.3646 41.3913 30.422 39.4097 32.1329C38.5975 32.8367 37.937 33.6164 38.0994 34.775C38.2294 35.7496 38.76 36.421 39.6804 36.7891C40.7416 37.2114 41.6728 36.9082 42.485 36.2261C47.4228 32.0354 49.9025 26.697 50 19.6151C49.9242 18.9221 49.8484 17.6227 49.621 16.3558V16.3666Z" fill={fillColor} />
                      <path d="M35.934 12.3485C34.9269 11.4498 33.66 11.2873 32.6205 12.0562C31.5701 12.8358 31.2128 14.2652 31.8625 15.3805C32.144 15.8786 32.5772 16.2901 32.967 16.7232C34.0498 17.936 34.5046 19.3437 34.2881 20.968C34.0932 22.3865 33.2594 23.4044 32.3173 24.4115C31.2236 25.581 31.2669 27.1078 32.3173 28.1256C33.3676 29.1435 34.862 29.1544 36.0315 28.104C38.3812 26.0033 39.4099 23.2961 39.5399 20.2966C39.4208 17.0914 38.2946 14.4493 35.934 12.3485Z" fill={fillColor} />
                    </svg>

                  )}
              </button>

              <textarea
                ref={textbox}
                style={{ resize: 'none' }}
                className={styles['chat-text']}
                placeholder="Envie uma mensagem..."
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  adjustHeightTextArea();
                }}
                onKeyDown={onEnterPress}
              ></textarea>

              {(message.trim().length > 0 || !hasMicActive) ? (

                <button
                  type="button"
                  data-kt-element="send"
                  onClick={() => { if (message.trim()) sendMessage('out', 1); }}
                >
                  <svg width="20" height="17.2" viewBox="0 0 50 43" fill="#708BC6" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.813 33.1499C24.0715 35.2089 22.0935 37.9966 18.8663 40.0209C19.167 35.7757 19.3868 32.0857 19.7338 28.4189C19.7916 27.8636 20.3931 27.2853 20.8674 26.8573C27.3335 20.9695 33.8112 15.0933 40.2889 9.21715C40.7169 8.82386 41.0986 8.39587 41.5035 7.97945C41.3994 7.79437 41.2837 7.62086 41.1796 7.43578C40.3352 7.80594 39.4329 8.08355 38.6579 8.56938C30.6765 13.5549 22.7066 18.552 14.7714 23.6184C13.5569 24.3934 12.5274 24.5207 11.1856 24.0696C8.32845 23.0863 5.39036 22.3345 2.54481 21.3165C1.59629 20.9811 0.844413 20.1251 0 19.5005C0.809711 18.8064 1.50375 17.8348 2.4407 17.4531C8.5251 15.0124 14.6558 12.6989 20.7633 10.3392C29.0686 7.1466 37.3855 3.94246 45.7024 0.749885C46.8823 0.298761 48.3513 -0.615056 49.242 0.622645C49.9129 1.5596 50.1442 3.16745 49.9129 4.35888C48.5595 11.2761 47.0211 18.1587 45.5404 25.0528C44.5919 29.483 43.6434 33.9133 42.6949 38.3436C42.6139 38.7253 42.5329 39.107 42.4288 39.4888C41.677 42.4269 40.1848 42.9705 37.6863 41.1776C35.5 39.6044 33.3485 37.9966 31.1854 36.4003C29.7395 35.3361 28.3052 34.2719 26.7783 33.1499H26.813Z"
                      fill="#6993ff" />
                  </svg>

                </button>
              ) : (
                <>

                  <button
                    onMouseDown={() => {
                      startListening()
                    }}
                    onMouseUp={() => {
                      stopListening()
                    }}
                    onTouchStart={() => {
                      startListening()
                    }}
                    onTouchEnd={() => {
                      stopListening()
                    }}
                  >
                    <svg width="20" height="28.57" viewBox="0 0 35 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.3252 9.27154C23.8152 9.27154 21.3352 9.31155 18.8652 9.25153C17.6352 9.22152 17.0752 9.61165 17.0952 10.9221C17.1052 12.1725 17.7152 12.5326 18.8252 12.5126C21.3052 12.4826 23.7852 12.5126 26.3752 12.5126V15.5436C23.8352 15.5436 21.3152 15.5436 18.7952 15.5436C17.8052 15.5436 17.1152 15.7637 17.0852 16.9941C17.0552 18.2345 17.4752 18.7947 18.7552 18.7747C21.2752 18.7247 23.8052 18.7647 26.3852 18.7647V21.8257C23.8752 21.8257 21.4452 21.8557 19.0152 21.8157C17.8452 21.7957 17.0552 21.9457 17.0652 23.4462C17.0852 24.9767 17.9752 25.0568 19.0852 25.0468C21.4652 25.0368 23.8452 25.0468 26.4052 25.0468C26.3752 28.4079 25.0352 30.9087 22.4152 32.6693C19.4852 34.6499 16.3152 34.9 13.1152 33.3595C9.8552 31.789 7.9952 29.1381 7.9152 25.5069C7.7952 19.9451 7.7952 14.3832 7.9152 8.82139C8.0052 4.68002 10.9252 1.25889 14.8752 0.288566C18.9752 -0.721768 23.0052 0.96879 25.1652 4.60999C25.9952 6.00045 26.6152 7.46094 26.3152 9.28154L26.3252 9.27154Z" fill={fillColor} />
                      <path d="M19.5353 45.3531C21.2353 45.3531 22.7853 45.3331 24.3453 45.3531C26.0953 45.3831 26.4953 45.8433 26.4853 47.7139C26.4853 49.5045 26.0853 49.9747 24.4053 49.9847C19.5753 50.0047 14.7453 50.0047 9.9053 49.9847C8.2553 49.9847 7.8553 49.4945 7.8453 47.6939C7.8453 45.8833 8.2453 45.3931 9.8553 45.3531C11.4553 45.3231 13.0653 45.3531 14.7653 45.3531V42.2021C12.8853 41.4718 10.9353 40.9517 9.2253 40.0014C3.3953 36.7603 0.465303 31.6186 0.0553031 24.9964C-0.0346969 23.5859 0.00530303 22.1655 0.035303 20.745C0.065303 19.1645 0.525303 18.7643 2.2253 18.7443C3.9953 18.7243 4.5753 19.1745 4.6353 20.725C4.6953 22.1855 4.6353 23.6559 4.7053 25.1164C4.9753 30.6383 8.8353 35.7199 13.7453 37.0504C19.2053 38.5309 24.4853 36.5302 27.7653 31.6586C29.0753 29.708 29.6653 27.5072 29.6853 25.1564C29.6953 23.5959 29.6453 22.0254 29.7253 20.4749C29.7853 19.2245 30.5553 18.7043 31.7953 18.7443C32.8853 18.7843 34.1953 18.6543 34.2553 20.1448C34.4553 24.4862 34.5553 28.8377 32.4153 32.869C29.9753 37.4505 26.2553 40.4015 21.2553 41.5919C19.7153 41.962 19.2053 42.5522 19.4453 44.0027C19.5053 44.3828 19.4953 44.7729 19.5353 45.3631V45.3531Z" fill={fillColor} />
                    </svg>
                  </button>

                </>
              )
              }



            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export { NewChatIa }